<script lang="ts">
	import { browser } from '$app/environment';
	import { setCookieTheme, Theme } from '$lib/serv/theme';
  import { setCookie } from '$lib/util/cookie';

	let activeBtn: Theme

	if (browser) {
		activeBtn = document?.querySelector('html')?.className as Theme;
	}

	function setTheme(theme: Theme) {
		const html = document.querySelector('html');
		html?.setAttribute('class', theme);
		html?.setAttribute('color-mode', theme);
		activeBtn = theme;
		setCookieTheme(theme); // This is only used for updating google maps.
		setCookie('theme', theme);
	}

</script>

<p class="label-m book grey">Display preference:</p>

<article class={activeBtn}>
	<button on:click={() => setTheme(Theme.Light)}>Light</button>
	<button on:click={() => setTheme(Theme.Dark)}>Dark</button>
	<button on:click={() => setTheme(Theme.Auto)}>Auto</button>
</article>

<style lang="scss">
	@use 'color';
	@use 'screen';

	p { padding-top: 1rem; }
	article {
		position: relative;
		width: 100%;
		height: 45px;
		margin-bottom: 1rem;
		background: color.$object-elevation-6dp;
		border-radius: 12px;
		padding: 4px;
		display: flex;
		>button {
			cursor: pointer;
			height: 100%;
			width: 33.3%;
			font-weight: 700;
			border-radius: 8px;
			color: color.$on-surface;
			z-index: 1;
			// &:hover {
			// 	background: color.$on-background-low-importance;
			// }
		}
		&:after {
			transition: all .3s ease-in-out;
			position: absolute;
			left: 4px; // this will change
			width: 32.5%;
			height: calc(100% - 8px);
			content: '';
			background: color.$theme-toggle-selected;
			border-radius: 8px;
			box-shadow: 0 0 8px 0 color.$object-elevation-6dp;
			z-index: 0;
		}
		&.light {
			&:after { left: 4px; }
		}
		&.dark {
			&:after {
				left: calc(4px + 33%);
				@media(screen.$xs) { left: calc(3px + 32%); }
			}
		}
		&.auto {
			&:after {
				left: calc(4px + 65%);
				@media(screen.$xs) { left: calc(3px + 64%); }
			}
		}
	}

</style>